import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "./translations";

const LanguageContext = createContext(null);

const get = (obj, path) =>
  path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);

const SUPPORTED = ["it", "en", "el", "ru", "fr", "es", "de", "sq"];

const detectLang = () => {
  if (typeof navigator === "undefined") return "it";
  const candidates = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  for (const c of candidates) {
    const base = c.toLowerCase().split("-")[0];
    const code = base === "gr" ? "el" : base; // some browsers report "gr" for Greek
    if (SUPPORTED.includes(code)) return code;
  }
  return "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("mr_lang") || detectLang();
  });

  useEffect(() => {
    localStorage.setItem("mr_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => {
    return (key) => {
      const val = get(translations[lang], key);
      if (val === undefined) return get(translations.it, key) ?? key;
      return val;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGS }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
